export const CHROME_EXTENSION_ID_LOCAL_STORAGE_KEY = 'chromeExtensionID';

export const CHROME_EXTENSION_ID = 'akcolkhleaionhppniljgglpeeohkljk';
export const BETA_CHROME_EXTENSION_ID = 'jpijniengfhajfadoflngpjhooogbfpi';
